import { render } from "./PublicStatisticsResults.vue?vue&type=template&id=38109d6a"
import script from "./PublicStatisticsResults.vue?vue&type=script&lang=js"
export * from "./PublicStatisticsResults.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/PublicStatistics/PublicStatisticsResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38109d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38109d6a', __exports__)) {
    api.reload('38109d6a', __exports__)
  }
  
  module.hot.accept("./PublicStatisticsResults.vue?vue&type=template&id=38109d6a", () => {
    api.rerender('38109d6a', render)
  })

}


export default __exports__